import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";

import { DomChangeDirective } from "../directive/oe-dom-change";
import { PipeModule } from "../pipe/pipe.module";
import { ChartModule } from "./chart/chart.module";
import { FlatWidgetComponent } from "./flat/flat";
import { FlatWidgetHorizontalLineComponent } from "./flat/flat-widget-horizontal-line/flat-widget-horizontal-line";
import { FlatWidgetLineComponent } from "./flat/flat-widget-line/flat-widget-line";
import { FlatWidgetLineItemComponent } from "./flat/flat-widget-line/flat-widget-line-item/flat-widget-line-item";
import { FlatWidgetLineDividerComponent } from "./flat/flat-widget-line-divider/flat-widget-line-divider";
import { FlatWidgetPercentagebarComponent } from "./flat/flat-widget-percentagebar/flat-widget-percentagebar";
import { FooterComponent } from "./footer/footer";
import { FooterNavigationModule } from "./footer/subnavigation/footerNavigation.module";
import { HistoryDataErrorModule } from "./history-data-error/history-data-error.module";
import { ModalModule } from "./modal/modal.module";
import { NavigationBreadCrumbsComponent } from "./navigation/bread-crumbs/breadcrumbs";
import { NavigationChipsComponent } from "./navigation/chips/chips";
import { NavigationPageComponent as NavigationViewComponent } from "./navigation/view/view";
import { PickdateModule } from "./pickdate/pickdate.module";
import { NotificationComponent } from "./shared/notification/notification";

@NgModule({
    imports: [
        BrowserModule,
        IonicModule,
        PipeModule,
        TranslateModule,
        HistoryDataErrorModule,
        FooterNavigationModule,
        ChartModule,
        PickdateModule,
        ReactiveFormsModule,
        RouterModule,
        ModalModule,
        DomChangeDirective,
    ],
    declarations: [

        // Flat
        FlatWidgetComponent,
        FlatWidgetHorizontalLineComponent,
        FlatWidgetLineComponent,
        FlatWidgetLineDividerComponent,
        FlatWidgetLineItemComponent,
        FlatWidgetPercentagebarComponent,

        // Others
        NotificationComponent,
        FooterComponent,
        NavigationViewComponent,
        NavigationChipsComponent,
        NavigationBreadCrumbsComponent,
    ],
    exports: [
        // Flat
        FlatWidgetComponent,
        FlatWidgetHorizontalLineComponent,
        FlatWidgetLineComponent,
        FlatWidgetLineDividerComponent,
        FlatWidgetLineItemComponent,
        FlatWidgetPercentagebarComponent,

        // Others
        NotificationComponent,
        FooterComponent,

        FooterNavigationModule,
        ChartModule,
        PickdateModule,
        ModalModule,
        NavigationViewComponent,
        NavigationChipsComponent,
        NavigationBreadCrumbsComponent,
        DomChangeDirective,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],

})
export class ComponentsModule { }
